import type { Icon } from '@tabler/icons-react';
import { PropsWithChildren } from 'react';

interface MethodPanelProps extends PropsWithChildren {
    icon: Icon;
    title: string;
    tagline: string;
}

export default function MethodPanel({ icon: Icon, title, tagline, children }: MethodPanelProps) {
    return (
        <div className="w-full">
            <div className="flex items-center gap-3 px-5 py-4 border-b-[0.5px] border-line">
                <div className="size-10 rounded-md flex items-center justify-center bg-fg/5 text-fg/80">
                    <Icon size={20} />
                </div>
                <div className="flex flex-col">
                    <h2 className="text-base font-bold text-fg">{title}</h2>
                    <p className="text-xs text-fg/68">{tagline}</p>
                </div>
            </div>
            {children}
        </div>
    );
}
